import { getLocale } from "../runtime";

const sv_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vad händer nu?`
};

const whathappensnow = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_whathappensnow(inputs)
	return "whatHappensNow";
};

export { whathappensnow as "whatHappensNow" };